export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "rank_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement réseau"])}
      },
      "en": {
        "rank_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network ranking"])}
      }
    }
  })
}
